import { EXPERIMENTS, isAssignedExperimentBucket } from '@src/experiments'
import CustomSection from '@src/quince-site-common/src/domains/CustomSection'
import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import Product from '@src/quince-site-common/src/domains/Product'
import Bundle from '@src/quince-site-common/src/domains/Product/BundleProduct'

const VALID_FS2_LENGTHS = [1, 4]

export const isFS2SectionDataValid = (prodDetails: CustomSection) => {
  const isValidVideoPresent = prodDetails?.videos?.[0]?.url
  const isValidImagePresent = prodDetails?.images?.[0]?.url

  const subSectionsLength = (prodDetails?.subSections || []).length
  const areSubSectionsValidLength = VALID_FS2_LENGTHS.includes(subSectionsLength)

  const areValidIconsPresent = (prodDetails?.subSections || []).filter(ss => ss.images?.length === 0).length === 0

  return (isValidVideoPresent || isValidImagePresent) && areSubSectionsValidLength && areValidIconsPresent
}

export const getSectionDetailsForDevices = (
  product: Product | Bundle,
  sectionType: CUSTOM_SECTION_TYPE,
): {
  desktopSectionDetails: CustomSection | undefined
  mobileSectionDetails: CustomSection | undefined
} => {
  const desktopSectionDetails = product.desktopSections.find(ds => ds.sectionType === sectionType)
  const mobileSectionDetails = product.mobileSections.find(ds => ds.sectionType === sectionType)

  return {
    desktopSectionDetails,
    mobileSectionDetails,
  }
}
export const checkIsNewLongFormSectionHidden = (section: CustomSection | undefined): boolean => {
  if (!section) {
    return true
  }

  const { runExperiment, experimentName } = section
  if (runExperiment && experimentName === EXPERIMENTS.NEW_LONG_FORM_MODULES.experimentName) {
    return !isAssignedExperimentBucket(
      EXPERIMENTS.NEW_LONG_FORM_MODULES.experimentName,
      EXPERIMENTS.NEW_LONG_FORM_MODULES.bucketNames.show,
    )
  }

  return false
}
